import React, { useState, useEffect } from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import { PDFViewer } from '@react-pdf/renderer';
import WRPdfDocument from './WRPdfDocument';

function PDFViewerModal({ show, onHide, wrDetails }) {
  const [isLoading, setIsLoading] = useState(true);

  // Use effect to set loading to false after a short delay
  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => {
        setIsLoading(false);
      }, 1500);
      
      return () => clearTimeout(timer);
    }
  }, [show]);

  return (
    <Modal 
      show={show} 
      onHide={onHide} 
      size="lg" 
      centered 
      dialogClassName="document-viewer-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>Warehouse Receipt</Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-0" style={{ height: '70vh' }}>
        {isLoading ? (
          <div className="d-flex justify-content-center align-items-center h-100">
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        ) : (
          <div style={{ height: '100%' }}>
            <PDFViewer 
              width="100%" 
              height="100%" 
              style={{ border: 'none' }}
            >
              <WRPdfDocument wrDetails={wrDetails} />
            </PDFViewer>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button 
          variant="outline-primary" 
          onClick={() => window.print()}
          className="me-auto"
        >
          Print
        </Button>
        <Button variant="secondary" onClick={onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default PDFViewerModal; 